import type { AudiencePerson } from './creatorAudience';

function cell(value: unknown): string {
  const text = String(value ?? '');
  // Keep names/contact fields as text when opened in spreadsheet applications.
  const safe = /^[\s]*[=+\-@]/.test(text) || /^[\t\r\n]/.test(text) ? `'${text}` : text;
  return `"${safe.replaceAll('"', '""')}"`;
}
const date = (value?: string | null) => value ? new Date(value).toLocaleString('th-TH', {timeZone: 'Asia/Bangkok', dateStyle: 'short', timeStyle: 'short'}) : '';
export function audienceCsv(rows: AudiencePerson[]): string {
  const financial = rows.some(row => row.wallet_current !== undefined);
  return '\uFEFF' + [
    ['User ID', 'ชื่อ', 'บัญชี', 'รีวิว', 'Last Active (โพสต์ล่าสุด)', 'สมัครเมื่อ', 'อีเมล', 'โทรศัพท์', 'Location', 'Multiple Location', 'แหล่งข้อมูล Location', 'รับข่าวสาร', ...(financial ? ['Wallet Current (บาท)','Wallet Total สะสม (บาท)','Referral (คน)'] : [])],
    ...rows.map(row => [row.id, row.name, row.username, row.review_count, date(row.last_post_at), date(row.created_at), row.email, row.phone,
      (row.active_provinces || []).find(p => p.current)?.name || '',
      (row.active_provinces || []).map(p => p.name).join(' / '), row.location_source === 'gps' ? 'GPS' : 'ข้อมูลบัญชี', row.marketing_enabled ? 'ใช่' : 'ไม่', ...(financial ? [row.wallet_current ?? '',row.wallet_total ?? '',row.referral_count ?? ''] : [])]),
  ].map(row => row.map(cell).join(',')).join('\r\n');
}
